<!-- <capture-image></capture-image> -->
<input type="file" [attr.aria-label]="getLabel()" [disabled]="isLocked"  data-ui-name="Input" data-ui-component="element-render-upload" data-testid="element-render-upload-input"/>
